import React from "react";
import { useTranslation } from "react-i18next";
import { Message as RsuitMessage } from "rsuite";
import { TypeAttributes } from "rsuite/esm/internals/types";

import {
    IWorkflowStep,
    IWorkflowWithData,
    WorkflowStatus,
    WorkflowStepStatus,
} from "store/workflows/workflows-types";

import { isCompleted } from "components/Workflows/workflows-helper";

interface Props {
    workflow: IWorkflowWithData<IWorkflowStep, any>;
}

const Message: React.FC<Props> = ({ workflow }: Props) => {
    const { t } = useTranslation();

    const completed = isCompleted(workflow.status);

    const getMessage = (): {
        type: TypeAttributes.Status;
        description: string;
    } => {
        switch (workflow.status) {
            case WorkflowStatus.Failed:
                return {
                    type: "error",
                    description: t("workflow.message.error"),
                };
            case WorkflowStatus.Terminated:
                return {
                    type: "warning",
                    description: t("workflow.message.termination"),
                };
            default:
                if (
                    workflow.steps.some(
                        (s) => s.status === WorkflowStepStatus.Skipped
                    )
                ) {
                    return {
                        type: "warning",
                        description: t("workflow.message.warning"),
                    };
                }

                return {
                    type: "info",
                    description: t("workflow.message.success"),
                };
        }
    };

    const message = getMessage();

    return completed ? (
        <RsuitMessage showIcon type={message.type}>
            {message.description}
        </RsuitMessage>
    ) : (
        <></>
    );
};

export default Message;
